import type { ProjectFieldDTO } from '@api/fastAPI.schemas'

// Mirrors the backend limits (ProjectFieldWriteDTO / project_fields use case).
export const MAX_TITLE_LENGTH = 25
export const MAX_OPTION_LABEL_LENGTH = 25
export const MAX_OPTION_VALUE_LENGTH = 2000
export const MAX_DESCRIPTION_LENGTH = 1000
/** A project's value for a text field. */
export const MAX_TEXT_VALUE_LENGTH = 2000

/** ASCII letters, words separated by spaces -- the title becomes a template placeholder name. */
export const TITLE_PATTERN = /^[A-Za-z]+( [A-Za-z]+)*$/

/** Built-in `project_data` placeholders of the documentation templates; a field must not shadow them. */
export const RESERVED_TEMPLATE_KEYS = [
  'project_name',
  'project_description',
  'project_address',
  'owner',
  'owner_address',
  'responsible_engineer',
  'responsible_engineer_contact',
  'processor',
  'processor_contact',
  'construction_company',
  'construction_company_address',
  'name',
  'project_number',
]

export const fieldTypeLabels: Record<ProjectFieldDTO['field_type'], string> = {
  text: 'Textfeld',
  select: 'Auswahlfeld',
}

export const normalizeTitle = (title: string): string => title.trim().split(/\s+/).join(' ')

/** The placeholder name in the documentation templates: the title with underscores for spaces. */
export const templateKey = (title: string): string => normalizeTitle(title).replace(/ /g, '_')

export const templatePlaceholder = (title: string): string =>
  `{{project_data.${templateKey(title)}}}`
